<div
  class="sp-width__full sp-height__full sp-border-radius__s sp-background__accent-contrast sp-padding__x2 sp-table__sticky-header">
  <div class="sp-row__space">
    <div class="sp-row__align">
      <h3 class="sp-color__primary sp-padding">{{ 'STORES.SETTINGS_LABEL' | translate }}</h3>
    </div>
  </div>
  <div class="sp-padding__top sp-row__space">
    <div class="sp-row__align">
      <h3 class="sp-color__accent sp-text__s sp-padding__left">{{ 'COMPANIES.SETTINGS_BASE_LABEL' | translate }}</h3>
    </div>
    <div class="sp-row__align">
      <div class="sp-circle__xs sp-margin__right">
        <mat-icon
          (click)="onSettingsClick(); $event.stopPropagation()"
          class="sp-color__accent sp-cursor__pointer">
          create
        </mat-icon>
      </div>
    </div>
  </div>
  <div
    class="sp-width__full sp-margin__top-x2 sp-company-details-general-settings__grid sp-grid__column-gap-x2 sp-grid__row-gap">
    <app-shared-status-indicator
      [label]="'COMPANIES.IS_STORE_PAYMENT_METHOD_ENABLED_LABEL'"
      [status_class]="getCompanySettingsBackgroundClass(company?.settings?.is_store_payment_method_enabled || false)">
    </app-shared-status-indicator>
    <app-shared-status-indicator
      [label]="'COMPANIES.IS_IBAN_REFUND_ENABLED_LABEL'"
      [status_class]="getCompanySettingsBackgroundClass(company?.settings?.is_iban_refund_enabled || false)">
    </app-shared-status-indicator>
    <app-shared-status-indicator
      [label]="'COMPANIES.IS_EXT_ORDER_ID_ENABLED_LABEL'"
      [status_class]="getCompanySettingsBackgroundClass(company?.settings?.is_ext_order_id_enabled || false)">
    </app-shared-status-indicator>
    <app-shared-status-indicator
      [label]="'COMPANIES.IS_TAX_DEDUCTION_ENABLED_LABEL'"
      [status_class]="getCompanySettingsBackgroundClass(company?.settings?.is_tax_deduction_enabled || false)">
    </app-shared-status-indicator>
    <app-shared-status-indicator
      [label]="'COMPANIES.IS_TAX_DATE_AND_NUMBER_ENABLED_LABEL'"
      [status_class]="getCompanySettingsBackgroundClass(company?.settings?.is_tax_date_and_number_enabled || false)">
    </app-shared-status-indicator>
    <app-shared-info
      [label]="'COMPANIES.TAX_DEDUCTION_TYPE_LABEL'"
      [content]="getDeductionsString()"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
  </div>
  <div class="sp-padding__top sp-row__space">
    <div class="sp-row__align">
      <h3 class="sp-color__accent sp-text__s sp-padding__left">
        {{ 'COMPANIES.PREPAID_CARDS_MANAGEMENT_LABEL' | translate }}
      </h3>
    </div>
    <div class="sp-row__align">
      <div class="sp-circle__xs sp-margin__right">
        <mat-icon
          (click)="onSettingsClick(); $event.stopPropagation()"
          class="sp-color__accent sp-cursor__pointer">
          create
        </mat-icon>
      </div>
    </div>
  </div>
  <div
    class="sp-width__full sp-margin__top-x2 sp-company-details-general-settings__grid sp-grid__column-gap-x2 sp-grid__row-gap">
    <app-shared-status-indicator
      [label]="'COMPANIES.BLOCK_PREPAID_CARD'"
      [status_class]="getCompanySettingsBackgroundClass(company?.settings?.is_prepaid_cards_blocked || false)">
    </app-shared-status-indicator>
    <app-shared-status-indicator
      [label]="'COMPANIES.BLOCK_PREPAID_CARD_ON_LONG'"
      [status_class]="getCompanySettingsBackgroundClass(company?.settings?.is_prepaid_cards_blocked_on_long || false)">
    </app-shared-status-indicator>
    <app-shared-status-indicator
      [label]="'COMPANIES.BLOCK_PREPAID_CARD_ON_ECOMMERCE'"
      [status_class]="
        getCompanySettingsBackgroundClass(company?.settings?.is_prepaid_cards_blocked_on_ecommerce || false)
      ">
    </app-shared-status-indicator>
  </div>
  <div class="sp-padding__top sp-row__space">
    <div class="sp-row__align">
      <h3 class="sp-color__accent sp-text__s sp-padding__left">
        {{ 'COMPANIES.TICKET_TITLE' | translate }}
      </h3>
    </div>
    <div class="sp-row__align">
      <div class="sp-circle__xs sp-margin__right">
        <mat-icon
          (click)="onTicketClick(); $event.stopPropagation()"
          class="sp-color__accent sp-cursor__pointer">
          create
        </mat-icon>
      </div>
    </div>
  </div>
  <div class="sp-width__full sp-margin__top-x2 sp-company-details-general-settings__grid sp-grid__column-gap-x2">
    <app-shared-status-indicator
      [label]="'COMPANIES.BNPL_LONG_TITLE'"
      [status_class]="getCompanySettingsBackgroundClass(company?.order_requirements?.is_bnpl_long_enabled || false)">
    </app-shared-status-indicator>
    <app-shared-info
      [label]="'STORES.MIN_AMOUNT_LABEL'"
      [content]="((company?.order_requirements?.min_amount ?? 20000) / 100).toString()"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-info
      [label]="'STORES.MAX_AMOUNT_LABEL'"
      [content]="((company?.order_requirements?.max_amount ?? 2000000) / 100).toString()"
      [content_class]="'sp-text__ellipsized'"></app-shared-info>
    <app-shared-status-indicator
      [label]="'COMPANIES.SDD_TITLE'"
      [status_class]="getCompanySettingsBackgroundClass(company?.order_requirements?.is_sdd_payment_enabled || false)">
    </app-shared-status-indicator>
  </div>
  <ng-container *ngIf="company?.order_requirements?.is_bnpl_long_enabled">
    <div class="sp-padding__top sp-row__space">
      <div class="sp-row__align">
        <h3 class="sp-color__accent sp-text__s sp-padding__left">
          {{ 'STORES.LONG_RANGE_TITLE' | translate }}
        </h3>
      </div>
      <div class="sp-row__align">
        <div class="sp-circle__xs sp-margin__right">
          <mat-icon
            (click)="onAllowedStepsClick(); $event.stopPropagation()"
            class="sp-color__accent sp-cursor__pointer">
            create
          </mat-icon>
        </div>
      </div>
    </div>
    <div
      class="sp-width__full sp-margin__top sp-company-details-general-settings-long-range__grid sp-grid__column-gap-x2 sp-grid__row-gap">
      <table
        mat-table
        [dataSource]="default_long_ranges || []"
        class="sp-width__full sp-table__headerless">
        <ng-container matColumnDef="amount_range">
          <th
            mat-header-cell
            *matHeaderCellDef></th>
          <td
            mat-cell
            *matCellDef="let long_range">
            <span>
              {{ getLongRangeLabel(long_range).min_label }} - {{ getLongRangeLabel(long_range).max_label }}€
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="allowed_steps">
          <th
            mat-header-cell
            *matHeaderCellDef></th>
          <td
            mat-cell
            *matCellDef="let long_range">
            <div class="sp-row__align">
              <mat-checkbox
                *ngFor="let step of long_range.allowed_steps"
                [class]="isChecked(step, long_range) ? 'sp-color__green' : ''"
                [checked]="isChecked(step, long_range)"
                [disabled]="true"
                class="sp-margin__right-x4">
                <span>{{ step }}</span>
              </mat-checkbox>
            </div>
          </td>
        </ng-container>
        <tr
          mat-header-row
          *matHeaderRowDef="displayed_columns"></tr>
        <tr
          mat-row
          *matRowDef="let row; columns: displayed_columns"></tr>
      </table>
    </div>
  </ng-container>
</div>
